import { Box, LinearProgress } from '@material-ui/core';
import { IEnrolmentFileType } from 'app/models/entities/IEnrolmentFileType';
import { IHostSite } from 'app/models/responses/IHostSite';
import { IProject } from 'app/models/responses/IProject';
import buildQuery from 'odata-query';
import axios from 'utils/axios';
import { ExceptionHandler } from 'components';
import { ODataGrid, SelectOneAsync } from 'components/_dashboard';
import { rootConfig } from 'config';
import { useSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';
import { IFileType } from 'app/models/responses/IFileType';

interface IProps {
  project: IProject;
}

const ExpectedFiles = ({ project }: IProps) => {
  const { enqueueSnackbar } = useSnackbar();

  const tableRef: any = useRef();
  const [fileTypeLookup, setFileTypeLookup] = useState<any>(undefined);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const select = ['id', 'name'];
        const queryString = buildQuery({ select });
        const response = await axios.get(`${rootConfig.odataRoute}/fileTypes${queryString}`);
        if (mounted) {
          const fileTypeLookups: any = {};
          response.data.value.forEach((fileType: IFileType) => {
            fileTypeLookups[fileType.id!] = `${fileType.name}`;
          });
          setFileTypeLookup(fileTypeLookups);
        }
      } catch (error) {
        enqueueSnackbar(<ExceptionHandler exception={error} />, { variant: 'error' });
      }
    })();

    return () => {
      mounted = false;
    };
  }, [enqueueSnackbar]);

  if (!fileTypeLookup) {
    return <LinearProgress />;
  }

  return (
    <Box>
      <ODataGrid<IEnrolmentFileType>
        title='Expected Files'
        tableRef={tableRef}
        entityType='enrolmentFileType'
        filter={{ projectId: project.id }}
        columns={[
          {
            field: 'id',
            hidden: true,
          },
          {
            field: 'description',
            title: 'Description',
          },
          {
            field: 'fileTypeId',
            title: 'File Type',
            editable: 'onAdd',
            lookup: fileTypeLookup,
            validate: (rowData) =>
              !rowData.fileTypeId ? { isValid: false, helperText: 'File Type is required' } : true,
            editComponent: (props) => (
              <SelectOneAsync
                name='fileTypeId'
                entityId={props.value || null}
                entityType='fileTypes'
                labelFields={['name']}
                filterFields={['name']}
                onChange={(event: any, value: any) => props.onChange(value?.id)}
                label='Search file type'
                required
                error={props.error}
              />
            ),
          },
          {
            field: 'projectId',
            hidden: true,
            initialEditValue: project.id,
          },
        ]}
        canDelete
        canAdd
        canEdit
      />
    </Box>
  );
};

export default ExpectedFiles;
